<template>
  <div class="content">
    <div class="container-fluid mt-7">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template v-slot:header>
            <div class="row align-items-center py-4">
              <div class="col-lg-6 col-8">
                <h3 class="mb-0">Instrument Table</h3>
              </div>
            </div>
          </template>
          <div>
            <div class="row flex-wrap mb-2 mb-md-0">
              <div class="col-12 col-md-2 mb-2 d-flex justify-content-start">
                <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="perPage" placeholder="Per page"
                  @change="handlePerPageChange">
                  <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 mt-lg-0  mb-2 d-flex justify-content-start">
                <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="tempFilterField" placeholder="Filter by"
                  @change="handleTempFieldChange">
                  <el-option class="select-primary" v-for="item in fieldOptions" :key="item" :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 d-flex justify-content-center">
                <base-input name="select" class="w-100 ml-2 mr-2">
                  <el-select v-model="tempSearchQuery" filterable placeholder="Select value"
                    :disabled="tempFilterField !== 'Instrument Code'">
                    <el-option v-for="option in selectOptions" :key="option.label" :label="option.label"
                      :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-12 col-md-2 d-flex justify-content-center justify-content-lg-start">
                <base-button class="ml-2 mt-0 mb-4 mr-2" size="md" type="primary"
                  @click="handleSearchChange">Search</base-button>
              </div>
            </div>
            <el-table :data="queriedDataWithFullName" row-key="id" header-row-class-name="thead-light"
              @sort-change="handleSortChange">
              <el-table-column label="slNo" prop="slNo" min-width="100px">
              </el-table-column>
              <el-table-column label="instrument Id" prop="instrumentId" min-width="190px" sortable>
              </el-table-column>
              <el-table-column label="Name" min-width="300px" sortable>
                <template v-slot:default="props">
                  <div class="font-weight-bold ">
                    {{ props.row.code }} ( {{ props.row.name }})
                  </div>
                  <div>
                    {{ props.row.exchangeToken }}
                    <span class="px-2 badge badge-sm" :class="`badge-primary`">
                      {{ props.row.exchange.name }}
                    </span>
                  </div>
                  <div> {{ props.row.assetType.name }}</div>
                </template>
              </el-table-column>
              <el-table-column label="status" prop="status" min-width="140px">
                <template v-slot:default="props">
                  <div class="col-auto px-0">
                    <span class="badge badge-lg" :class="[setStatusColor(props.row.status, props.row.expiry)]">
                      {{ getStatusText(props.row.status, props.row.expiry) }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="lotSize" prop="lotSize" min-width="140px" sortable>
              </el-table-column>
              <el-table-column label="expiry" prop="expiry" min-width="160px" sortable>
                <template v-slot:default="props">
                  <span v-if="props.row.expiry">{{ formatDate(props.row.expiry) }}</span>
                  <span v-else>NA</span>
                </template>
              </el-table-column>
              <el-table-column label="broker" min-width="140px" sortable>
                <template v-slot:default="props">
                  <div> {{ props.row.broker.name }}</div>
                </template>
              </el-table-column>
              <el-table-column label="instrument Type" min-width="210px" sortable>
                <template v-slot:default="props">
                  <div> {{ props.row.instrumentType.name }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <template v-slot:footer>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="">
                <p v-if="isSuccess" class="card-category">
                  Showing {{ from + 1 }} to {{ Math.min(to, total) }} of {{ total }} entries
                </p>
              </div>
              <base-pagination v-if="isSuccess" class="pagination-no-border" v-model="currentPage" :per-page="perPage"
                :total="total" :page-count="totalPages" @update:modelValue="handleFetchNextPage">
              </base-pagination>
            </div>
          </template>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ElTable,
  ElTableColumn,
  ElSelect,
  ElOption,
  ElInput,
} from "element-plus";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BasePagination from "@/components/BasePagination";
export default {
  components: {
    BasePagination,
    RouteBreadCrumb,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElTable.name]: ElTable,
    [ElInput.name]: ElInput,
    [ElTableColumn.name]: ElTableColumn,
  },
  computed: {
    pagedData() {
      return this.tableData;
    },
    queriedDataWithFullName() {
      const startIndex = this.from + 1;
      return this.pagedData.map((item, index) => ({
        ...item,
        slNo: startIndex + index,
      }));
    },
    from() {
      return (this.currentPage - 1) * this.perPage;
    },
    to() {
      return Math.min(this.from + this.perPage, this.total);
    },
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      totalElements: 0,
      totalPages: 0,
      total: 0,
      searchQuery: '',
      tempSearchQuery: '',
      direction: "DESC",
      sortedColumn: "code",
      propsToSearch: ["code", "Active"],
      tableData: [],
      searchedData: [],
      isSuccess: false,
      statusText: '',
      fieldOptions: ['Active', 'All', 'InActive', 'Instrument Code'],
      filterField: 'Active',
      tempFilterField: '',
      selectOptions: [],
    };
  },
  methods: {
    setStatusColor(status, expiry) {
      const inputDate = new Date(expiry);
      const currentDate = new Date();
      inputDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);
      return inputDate < currentDate ? "badge-warning" : "badge-success";
    },
    getStatusText(status, expiry) {
      const inputDate = new Date(expiry);
      const currentDate = new Date();
      inputDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);
      return inputDate < currentDate ? 'EXPIRED' : status;
    },
    setTable(pageNo, pageSize, sortBy, direction, filter, filterField) {
      let data = {
        pageNo: pageNo - 1,
        pageSize: pageSize,
        sortBy: sortBy,
        direction: direction,
        filter: filter,
        filterField: filterField,
      };
      this.$store.dispatch("instrumentStore/getInstrumentDetails", data, { root: true })
        .then(response => {
          this.tableData = response.server.data.instrumentBean;
          this.totalElements = this.tableData.length;
          this.currentPage = response.server.data.currentPage + 1;
          this.totalPages = response.server.data.totalPages;
          this.total = response.server.data.totalElements;
          this.isSuccess = this.tableData.length > 0;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSortChange({ prop, order }) {
      let sortProp = prop || 'code';
      let sortOrder = order || 'ascending';
      this.setTable(this.currentPage, this.perPage, sortProp, this.mapSortOrder(sortOrder), this.searchQuery, this.filterField);
    },
    mapSortOrder(order) {
      const orderMap = {
        "ascending": "ASC",
        "descending": "DESC",
      };
      return orderMap[order];
    },
    handlePerPageChange(newPerPage) {
      this.perPage = newPerPage;
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    },
    handleFetchNextPage(newPage) {
      this.currentPage = newPage;
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    },
    handleSearchChange() {
      if (this.tempSearchQuery == 'InActive') {
        this.searchQuery = 'Active';
      } else {
        this.searchQuery = this.tempSearchQuery;
      }
      this.setTable(1, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
    },
    handleTempFieldChange() {
      this.tempSearchQuery = '';
      this.searchQuery = '';
      this.filterField = this.tempFilterField.replace(/ /g, '');
      if (this.filterField == 'Active') {
        this.selectOptions = [{ label: 'Active', value: 'Active' }];
      } else if (this.filterField == 'InActive') {
        this.selectOptions = [{ label: 'InActive', value: 'InActive' }];
      } else if (this.filterField == 'All') {
        this.selectOptions = [{ label: 'All', value: 'All' }];
      } else {
        let data = {
          type: 'instrument-code'
        };
        if (sessionStorage.getItem(data.type + "-reference-data")) {
          this.selectOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
        } else {
          this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
            .then(response => {
              this.selectOptions = response.server.data;
            })
            .catch(error => {
              console.log(error);
            });
        }
      }
    },
    formatDate(dateString) {
      if (!dateString) return "NA";
      const date = new Date(dateString);
      if (isNaN(date)) return "NA";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
  mounted() {
    this.selectOptions = [{ label: 'Active', value: 'Active' }];
    this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField);
  }
};
</script>
<style></style>
